class SwiperModulo extends HTMLElement {
    constructor() {
        super();
    }   

    connectedCallback(){
        this.initSlider();
    }

    initSlider() {
        this.swiper = new Swiper(".swiper-modulo", {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 20,
            centeredSlides: false,
          navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
        });
    }
}

customElements.define('swiper-modulo', SwiperModulo);